import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Divider from '@material-ui/core/Divider'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'

// core components
import MyHeader from 'components/Header/MyHeader.js'
import MyFooter from 'components/Footer/MyFooter.js'
import MyHeaderLinks from 'components/Header/MyHeaderLinks.js'

import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import Parallax from 'components/Parallax/Parallax.js'
import Card from 'components/Card/Card.js'
import CardBody from 'components/Card/CardBody.js'

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

import styles from 'assets/jss/material-kit-react/views/cultruePage.js'

import pic1 from 'assets/img/culturePage/pic1.png'

const useStyles = makeStyles(styles)

export default function CulturePage(props) {
  const classes = useStyles()
  const { ...rest } = props
  // const imageClasses = classNames(classes.imgRaised, classes.imgRoundedCircle, classes.imgFluid)
  // const navImageClasses = classNames(classes.imgRounded, classes.imgGallery)
  return (
    <div>
      <MyHeader color="white" brand="江苏硕佰建筑科技有限公司" fixed rightLinks={<MyHeaderLinks />} {...rest} />
      <Parallax small image={require('assets/img/culturePage/culture.jpg')}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>硕佰文化</h1>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <img src={pic1} alt="文化1" className={classes.leftImg} />
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <List className={classes.listRoot}>
                  <ListItem alignItems="flex-start">
                    <ListItemAvatar>
                      <ArrowForwardIosIcon color="primary" className={classes.listIcon} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={<h3 className={classes.listTextHeader}>愿景</h3>}
                      secondary="在节能减排历史的长河中， 留下硕佰奋斗的足迹"
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                  <ListItem alignItems="flex-start">
                    <ListItemAvatar>
                      <ArrowForwardIosIcon color="primary" className={classes.listIcon} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={<h3 className={classes.listTextHeader}>使命</h3>}
                      secondary="致力于为客户提供高附加值的解决方案"
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                  <ListItem alignItems="flex-start">
                    <ListItemAvatar>
                      <ArrowForwardIosIcon color="primary" className={classes.listIcon} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={<h3 className={classes.listTextHeader}>价值观</h3>}
                      secondary="客户引导 科技引领 创新分享 止于至善"
                    />
                  </ListItem>
                </List>
              </GridItem>
            </GridContainer>
            <div>
              <h3 className={classes.containerTitle}>价 值 观</h3>
              <GridContainer>
                <GridItem xs={12} sm={6} md={6} lg={3}>
                  <Card>
                    <svg className={classes.cardIcon} aria-hidden="true">
                      <use xlinkHref="#icon-kehu"></use>
                    </svg>
                    <h4 className={classes.cardTitle}>客户引导</h4>
                    <CardBody>
                      <div className={classes.description}>
                        <p>洞悉客户痛点</p>
                        <p>满足客户需求</p>
                        <p>超越客户期待</p>
                      </div>
                    </CardBody>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={6} lg={3}>
                  <Card>
                    <svg className={classes.cardIcon} aria-hidden="true">
                      <use xlinkHref="#icon-keji"></use>
                    </svg>
                    <h4 className={classes.cardTitle}>科技引领</h4>
                    <CardBody>
                      <div className={classes.description}>
                        <p>学术团队打造</p>
                        <p>前沿技术应用</p>
                        <p>科技成功转化</p>
                      </div>
                    </CardBody>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={6} lg={3}>
                  <Card>
                    <svg className={classes.cardIcon} aria-hidden="true">
                      <use xlinkHref="#icon-chuangxin"></use>
                    </svg>
                    <h4 className={classes.cardTitle}>创新共享</h4>
                    <CardBody>
                      <div className={classes.description}>
                        <p>打破传统思维</p>
                        <p>满怀创造激情</p>
                        <p>共享健康生活</p>
                      </div>
                    </CardBody>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={6} lg={3}>
                  <Card>
                    <svg className={classes.cardIcon} aria-hidden="true">
                      <use xlinkHref="#icon-xietong1"></use>
                    </svg>
                    <h4 className={classes.cardTitle}>止于至善</h4>
                    <CardBody>
                      <div className={classes.description}>
                        <p>高效协同工作</p>
                        <p>持续查漏补缺</p>
                        <p>形成闭环反馈</p>
                      </div>
                    </CardBody>
                  </Card>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
      </div>
      <MyFooter />
    </div>
  )
}
